import React, { useRef, useEffect, useState } from "react";

export const useInterval = ({ callback, interval }) => {
  const [state, setState] = useState({ active: true, id: null });
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (state.id) {
      clearInterval(state.id);
    }

    const id = state.active ? setInterval(tick, interval) : null;
    setState((state) => ({ ...state, id }));
    return () => id && clearInterval(id);
  }, [state.active]);

  return {
    active: (isActive) => setState((state) => ({ ...state, active: isActive })),
  };
};
